import { IReportContact } from 'dashboard409a/services/types';

// Stable Select value: prefer Attio recordId, fall back to email (emails alone can be blank).
export const contactSelectKey = (contact: IReportContact, index: number): string =>
  contact.recordId || contact.email || `contact-${index}-${contact.name ?? ''}`;

// Attio only guarantees a full name, so fall back to its leading token.
export const resolveContactFirstName = (contact?: IReportContact | null): string => {
  const firstName = contact?.firstName?.trim();
  if (firstName) {
    return firstName;
  }
  const fullName = contact?.name?.trim();
  return fullName ? fullName.split(' ')[0] : '';
};
